import { userData, eventEmitter } from './baseData'

function initFusi() {
    if (typeof Ponyx === 'undefined') {
        return;
    }

    // Читаем текущую корзину из localStorage
    let currentCart = [];
    try {
        const basketItemsData = JSON.parse(window.localStorage.getItem('basketItemsData') || '[]');
        if (Array.isArray(basketItemsData)) {
            currentCart = basketItemsData.map(item => ({
                product_id: item.productId,
                quantity: item.quantity
            }));
        }
    } catch (e) {
        console.error('Fusi: Error parsing basketItemsData', e);
    }

    // Инициализация виджета
    Ponyx('init', {
        language: 'uk',
        theme: 'light',
        position: 'hidden',
        autoOpen: false,
        externalClientId: userData.ID || null,
        currentCart: currentCart,
        callbacks: {
            onAddToCart: ({ id, quantity = 1 } = {}) => {
                console.info('[Fusi SDK] onAddToCart called with:', { id, quantity });
                if (!id) {
                    console.error('[Fusi SDK] onAddToCart error: Product ID is missing');
                    return Promise.reject({ success: false, error: 'Product ID is required in SDK object { id, quantity? }' });
                }
                console.info('[Fusi SDK] Emitting addToCart event to site');
                return Promise.resolve(eventEmitter.emit('addToCart', { productId: id, quantity, openWindow: false, source: 'fusi' }));
            },
            onRemoveFromCart: ({ id } = {}) => {
                console.info('[Fusi SDK] onRemoveFromCart called with:', { id });
                if (!id) {
                    console.error('[Fusi SDK] onRemoveFromCart error: Product ID is missing');
                    return Promise.reject({ success: false, error: 'Product ID is required in SDK object { id }' });
                }

                let cartId = null;
                try {
                    const basketItemsData = JSON.parse(localStorage.getItem('basketItemsData') || '[]');
                    const item = basketItemsData.find(i => String(i.productId) === String(id));
                    if (item) cartId = item.cartId;
                    console.info('[Fusi SDK] onRemoveFromCart: Found cartId:', cartId, 'for productId:', id);
                } catch (e) {
                    console.error('[Fusi SDK] onRemoveFromCart error reading basketItemsData:', e);
                }

                return eventEmitter.emit('removeFromCart', { cartId: cartId, productId: id, source: 'fusi' });
            },
            onUpdateCartItem: ({ id, quantity } = {}) => {
                console.info('[Fusi SDK] onUpdateCartItem called with:', { id, quantity });
                if (!id || quantity === undefined) {
                    console.error('[Fusi SDK] onUpdateCartItem error: Missing id or quantity');
                    return Promise.reject({ success: false, error: 'Product ID and quantity are required in SDK object { id, quantity }' });
                }

                let cartId = null;
                try {
                    const basketItemsData = JSON.parse(localStorage.getItem('basketItemsData') || '[]');
                    const item = basketItemsData.find(i => String(i.productId) === String(id));
                    if (item) cartId = item.cartId;
                    console.info('[Fusi SDK] onUpdateCartItem: Found cartId:', cartId, 'for productId:', id);
                } catch (e) {
                    console.error('[Fusi SDK] onUpdateCartItem error reading basketItemsData:', e);
                }

                if (!cartId) {
                    console.error('[Fusi SDK] onUpdateCartItem error: Cart ID not found for updating');
                    return Promise.reject({ success: false, error: 'Cart ID not found for updating' });
                }

                return eventEmitter.emit('changeCartQuantity', { cartId: cartId, quantity: quantity, openWindow: false, source: 'fusi' });
            }
        }
    });

    // Сайт → Чат: пробрасываем конкретные события (добавление, удаление, обновление)
    eventEmitter.on('addedToCart', data => {
        if (data.source === 'fusi') return;
        Ponyx('update_cart', { action: 'add', product_id: data.productId, quantity: data.quantity || 1 });
    });

    eventEmitter.on('removedCartItem', data => {
        if (data.source === 'fusi') return;
        Ponyx('update_cart', { action: 'remove', product_id: data.productId });
    });

    eventEmitter.on('updatedCartItem', data => {
        if (data.source === 'fusi') return;
        Ponyx('update_cart', { action: 'update', product_id: data.productId, quantity: data.quantity || 1 });
    });

    eventEmitter.on('basketOpened', () => {
        Ponyx('close');
    });
}

export default initFusi;
